<template>
  <v-container>
    <v-card class="mb-3">
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title>{{
          preMatricula.candidato.dadosPessoais.nome
        }}</v-toolbar-title>
      </v-toolbar>
      <dados-basicos-candidato
        :candidato="preMatricula.candidato"
      ></dados-basicos-candidato>
    </v-card>
    <v-card class="mb-3">
      <v-card
        v-for="analise in preMatricula.analises"
        :key="analise.id"
        class="mb-3"
      >
        <v-toolbar :color="analise.status.cor || 'grey'" dark flat>
          <v-toolbar-title>Análise: {{ analise.descricao }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            fab
            dark
            color="green"
            v-if="analise.parecer && analise.parecer.permiteRecurso"
            @click="emitirRecurso(analise)"
          >
            <v-icon dark> mdi-pencil </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div v-if="analise.status.codigo != 'AGUARDA_RECURSO' && analise.status.codigo != 'PRAZO_EXPIRADO'">
            Status: {{ analise.status.descricao }}
          </div>
          <div v-else>
            <div
              v-if="analise.parecer.dataLimiteParaRecursoExpirada"
              class="error"
            >
              <span class="white--text">
                Prazo para recurso expirado:
                {{ analise.parecer.dataLimiteParaRecurso }}</span
              >
            </div>
            <div v-else class="green darken-2">
              <span class="white--text">
                Prazo para recurso:
                {{ analise.parecer.dataLimiteParaRecurso }}</span
              >
            </div>
          </div>
          <v-simple-table dense>
            <template
              v-slot:default
              v-if="analise.status.codigo != 'AGUARDA_ANALISE'"
            >
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left">Descrição</th>
                  <th class="text-left">Tipo</th>
                  <th width="50px" class="text-left">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="analise.parecer">
                  <td>Parecer Inicial</td>
                  <td>{{ analise.parecer.texto | truncate(70, "...") }}</td>
                  <td>{{ analise.parecer.situacao.descricao }}</td>
                  <td>
                    <v-icon small @click="visualizarParecer(analise.parecer)">
                      mdi-eye
                    </v-icon>
                  </td>
                </tr>
                <tr v-if="analise.recurso">
                  <td>Recurso</td>
                  <td>{{ analise.recurso.texto | truncate(70, "...") }}</td>
                  <td>{{ analise.recurso.status.descricao }}</td>
                  <td>
                    <v-icon small @click="visualizarRecurso(analise.recurso)">
                      mdi-eye
                    </v-icon>
                  </td>
                </tr>
                <tr v-if="analise.parecerDoRecurso">
                  <td>Parecer do Recurso</td>
                  <td>
                    {{ analise.parecerDoRecurso.texto | truncate(70, "...") }}
                  </td>
                  <td>{{ analise.parecerDoRecurso.situacao.descricao }}</td>
                  <td>
                    <v-icon
                      small
                      @click="visualizarParecer(analise.parecerDoRecurso)"
                    >
                      mdi-eye
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-container v-if="analise.descricao == 'Renda'" >
          <table-doc-renda-analise :preMatricula="preMatricula" >
          </table-doc-renda-analise>      
        </v-container>
        </v-card-text>
      </v-card>
    </v-card>

    <v-card>
      <v-toolbar color="secondary" dark flat>
        <v-toolbar-title>Histórico de alterações</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          dense
          :headers="headersHistorico"
          :items="preMatricula.historico"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-row justify="center">
      <dialogo-parecer-recurso tipo="recurso" @salvou="salvouRecurso" @finalizou="salvouRecurso" :rascunho="rascunhoRecurso" :mostrar="dlgRecurso" @cancelar="dlgRecurso = false"></dialogo-parecer-recurso>

      <dialog-visualizar-item-prematricula
        @fechar="dlgVisualizarItem = !dlgVisualizarItem"
        :visivel="dlgVisualizarItem"
        :item="itemVisualizacao"
        :mostrarArquivos="mostrarAnexosDoItem"
      ></dialog-visualizar-item-prematricula>
    </v-row>
  </v-container>
</template>
<script>
import * as PreMatriculaService from "@/services/prematricula.service";
import PreMatricula from "@/models/prematricula";
import DadosBasicosCandidato from "@/components/DadosBasicosCandidato";
import DialogVisualizarItemPrematricula from "@/components/DialogVisualizarItemPrematricula";
import DialogoParecerRecurso from '../../components/DialogoParecerRecurso.vue';
import DocRendaAnalise from '@/components/DocRendaAnalise.vue';

export default {
  name: "acompanhamento",
  components: {
    "dados-basicos-candidato": DadosBasicosCandidato,
    "dialog-visualizar-item-prematricula": DialogVisualizarItemPrematricula,
    DialogoParecerRecurso,
    "table-doc-renda-analise":DocRendaAnalise,
  },
  data() {
    return {
      titulo: this.$route.meta.titulo,
      preMatricula: new PreMatricula(),
      rascunhoRecurso: {},
      dlgRecurso: false,
      dlgVisualizarItem: false,
      itemVisualizacao: {},
      mostrarAnexosDoItem: false,
      mostrarConfirmacaoRecurso: false,
      headersHistorico: [
        {
          text: "Instante",
          align: "start",
          sortable: false,
          value: "instante",
        },
        {
          text: "Descrição",
          align: "start",
          sortable: false,
          value: "descricao",
        },
      ],
    };
  },
  mounted() {
    this.loadPreMatricula();
  },
  methods: {
    loadPreMatricula() {
      this.$nprogress.start();
      PreMatriculaService.getOne()
        .then((pm) => {
          this.preMatricula = pm;
          if (this.preMatricula.status.codigo == "RASCUNHO") {
            this.$router.push("inscricao");
          }
          console.log(pm);
        })
        .finally(() => this.$nprogress.done());
    },
    emitirRecurso(analise) {
      this.$nprogress.start();
      PreMatriculaService.getRascunhoAnalise(analise.id)
        .then((rascunho) => {
          this.rascunhoRecurso = rascunho;
          this.dlgRecurso = true;
        })
        .finally(() => this.$nprogress.done());
    },
    salvouRecurso() {
      this.dlgRecurso = false;
      this.loadPreMatricula();
    },
    cancelarInclusao() {
      this.dlgRecurso = false;
    },
    visualizarParecer(item) {
      this.mostrarAnexosDoItem = false;
      this.visualizarItem(item);
    },
    visualizarRecurso(item) {
      this.mostrarAnexosDoItem = true;
      this.visualizarItem(item);
    },
    visualizarItem(item) {
      this.itemVisualizacao = item;
      this.dlgVisualizarItem = true;
    },
    addAnexoRecurso(event) {
      var arquivo = event.target.files[0];
      this.recurso.anexos.push(arquivo);
      this.$refs.fileInput.value = "";
    },
    removeAnexoRecurso(anexo) {
      this.recurso.anexos.splice(this.recurso.anexos.indexOf(anexo), 1);
    },
    confirmarSalvarRecurso(){
      this.mostrarConfirmacaoRecurso = true;
    },
    cancelarConfirmacaoRecurso(){
      this.mostrarConfirmacaoRecurso = false;
    }
  },
};
</script>


